<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title border-0 pb-0" >Registered User Expenses</h5>


    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Registered By</label>
        <input [(ngModel)]="Filter_Username" (keyup)="Change_Filter()" name="Filter_title" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> Decree Number </label>
        <input [(ngModel)]="Filter_Code" (keyup)="Change_Filter()" name="Filter_Code" type="text" class="form-control"  placeholder="Type here to search...">
      </div>

    </div>

    <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!InProccessing" type="button" (click)="ReadData_Funds()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

    <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Customer Name</th>
              <th>Decree Number</th>
              <th>Expense Amount (IRR)</th>
              <th>Expense Date</th>
              <th>Expense Title</th>
              <th>Description</th>
              <th>Attachment</th>
              <th>Date</th>
              <th>Registered By</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds
            |filter:Filter_Username:'username'
            |filter:Filter_Code:'code'
            | paginate
                    : {
                        id: 'DataList_UserTable_Pay',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Funds
                        |filter:Filter_Username:'username'
                        |filter:Filter_Code:'code'
                        ).length
                      }
            ">
             <td>
                <p *ngIf="item.visible">{{DataList_Funds.indexOf(item)+1}}</p>
                <span *ngIf="!item.visible" class="badge badge-pill badge-info float-right mt-1">New</span>
             </td>
             <td>{{item.code}}</td>
             <td>{{item.customer}}</td>
             <td>{{item.code2}}</td>
             <td>{{item.price | number}}</td>
             <td>{{item.price_date}}</td>
             <td>{{item.title}}</td>
             <td>{{item.dsc}}</td>
             <td>
              <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Funds/{{item.src}}"   *ngIf="item.src" ><i class="fa fa-download"></i> Download </a>
             </td>

             <td>{{item.subdate}}</td>
             <td>{{item.username}}</td>
             <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item,1)"><i class="fa fa-check"></i> Approve </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item,-1)"><i class="fa fa fa-times-rectangle"></i> Reject </a>
                    </div>
                </div>

            </div>
            </td>
            </tr>
          </tbody>
        </table>
    </div>

    <pagination-controls
    id="DataList_UserTable_Pay"
    nextLabel="Next"
    previousLabel="Previous"
    (pageChange)="page = $event"
  ></pagination-controls>

  </div>
</div>


<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete_Status==-1" class="modal-title pull-left"> Reject ID '{{Data_Seleted_Delete.code}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete_Status==1" class="modal-title pull-left">  Approve ID '{{Data_Seleted_Delete.code}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input [(ngModel)]="OperationDsc"  name="OperationDsc" type="text" class="form-control"  placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete_Status==-1" type="button" class="btn btn-danger" (click)="AnswerReview()"> Reject <i class="fa fa-times-rectangle"></i></button>
    <button *ngIf="Data_Seleted_Delete_Status==1" type="button" class="btn btn-success" (click)="AnswerReview()"> Approve <i class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
